import { Modal, Stack } from "@mui/material";
import { CloseIcon } from "components/icons";

export const Lightbox = ({
  url,
  filename: _filename,
  open,
  onClose,
  fileType,
}: {
  url: string;
  filename: string;
  open: boolean;
  onClose: () => void;
  fileType: string;
}) => {
  // const handleDownload = () => {
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  return (
    <Modal open={open} onClose={onClose} style={{ outline: 0 }}>
      <Stack sx={{ outline: 0 }}>
        <Stack
          direction={"row"}
          sx={{
            height: "42px",
            width: "100%",
            alignItems: "center",
            justifyContent: "flex-end",
            backgroundColor: "#000",
            gap: "24px",
            padding: "16px",
          }}
        >
          {/* <Box sx={{ cursor: "pointer" }} onClick={handleDownload}>
            <DownloadCurvedIcon htmlColor={"#FFF"} />
          </Box> */}

          <CloseIcon
            htmlColor={"#FFF"}
            sx={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </Stack>
        <Stack
          sx={{
            height: "calc(100vh - 42px)",
            width: "100%",
            padding: "24px",
            justifyContent: "center",
            alignItems: "center",
            // background: "#000",
            backdropFilter: "blur(4px)",
          }}
        >
          <DisplayFile fileType={fileType} url={url} />
          {/* <img
            src={url}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          /> */}
        </Stack>
      </Stack>
    </Modal>
  );
};

const DisplayFile = ({ fileType, url }: { fileType: string; url: string }) => {
  switch (fileType) {
    case "application/pdf":
      return (
        <iframe
          src={url}
          width="100%"
          height="600px"
          title="PDF Viewer"
          style={{ border: "none" }}
        >
          This browser does not support PDFs. Please download the PDF to view
          it: <a href={url}>Download PDF</a>.
        </iframe>
      );
    case "image/png":
    case "image/jpg":
    case "image/jpeg":
      return (
        <img
          alt="preview"
          src={url}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      );
  }
  return <></>;
};
